import { createSlice } from "@reduxjs/toolkit";
import { appStorageKey, tenant } from "../utils/global";

const safeParse = (value, fallback = null) => {
  if (value === undefined || value === null || value === "undefined" || value === "null" || value === "") {
    return fallback;
  }
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

const getStoredBranch = () => {
  const storedBranch = safeParse(localStorage.getItem(appStorageKey("selectedBranch")));
  if (storedBranch) {
    return storedBranch;
  }
  const tenantData = tenant();
  const firstCompany = tenantData?.companies?.[0];
  const firstBranch = firstCompany?.branches?.[0];
  const langFromI18n = String(localStorage.getItem("i18nextLng") || "")
    .toLowerCase()
    .startsWith("ar")
    ? "ar"
    : "en";
  const defaultLangFromSettings =
    firstCompany?.settings?.generalSettings?.find?.((setting) => setting?.name === "DEFAULT_LANG")?.value ||
    firstCompany?.settings?.generalSettings?.find?.((setting) => setting?.settingName === "DEFAULT_LANG")?.value;
  const desiredLang = (defaultLangFromSettings || langFromI18n || "en")
    .toLowerCase()
    .startsWith("ar")
    ? "ar"
    : "en";
  const branchNameText =
    firstBranch?.name?.find?.((name) => name?.lang === desiredLang)?.text ||
    firstBranch?.name?.find?.((name) => name?.lang === "ar")?.text ||
    firstBranch?.name?.[0]?.text ||
    (desiredLang === "ar" ? "الفرع" : "Select a Branch");

  return {
    name: branchNameText,
    value: firstBranch?._id || firstBranch?.id,
  };
};

const initialState = getStoredBranch();

const currentBranchSlice = createSlice({
  name: "currentBranch",
  initialState,
  reducers: {
    setCurrentBranch: (state, action) => {
      state.name = action.payload.name;
      state.value = action.payload.value;
      state.updatedAt = Date.now();
      localStorage.setItem(
        appStorageKey("selectedBranch"),
        JSON.stringify({
          name: action.payload.name,
          value: action.payload.value,
          updatedAt: state.updatedAt,
        })
      );
    },
  },
});

export const { setCurrentBranch } = currentBranchSlice.actions;
export default currentBranchSlice.reducer;
